(() => {
  if (customElements.get('bf-hero-countdown')) return;
  customElements.define('bf-hero-countdown', class extends HTMLElement {
    connectedCallback() {
      this.update = () => {
        const start = Date.parse(this.dataset.start);
        const end = Date.parse(this.dataset.end);
        const now = Date.now();
        const active = Number.isFinite(start) && Number.isFinite(end) && end > start && now >= start && now < end;
        this.hidden = !active;
        if (!active) return;
        const remaining = Math.ceil((end - now) / 1000);
        const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
        for (const [unit, value] of Object.entries(values)) {
          this.querySelector(`[data-unit="${unit}"]`).textContent = String(value).padStart(2, '0');
        }
      };
      this.update();
      this.timer = window.setInterval(this.update, 1000);
    }
    disconnectedCallback() { window.clearInterval(this.timer); }
  });
})();
